var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    transform: "translate(-508.000000, -3306.000000)",
    fill: "#1330E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(280.000000, 3158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(208.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(20.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0000412,0 C5.37225516,0 0,5.37299661 0,12.0000412 C0,18.6270858 5.37225516,24 12.0000412,24 C18.6278272,24 24.0000824,18.6270034 24.0000824,11.9999588 C24.0000824,5.37291423 18.6277448,0 12.0000412,0 Z M19.8742135,5.80798369 C21.1641808,7.44602309 21.9539954,9.49194526 22.0161953,11.7187001 C19.3237242,11.2469698 17.0017335,11.2327174 14.995438,11.5507193 C14.7412012,10.967194 14.4794675,10.4002279 14.2109783,9.85122151 C16.3627638,8.96625349 18.2925247,7.67546229 19.8742135,5.80798369 Z M18.4934591,4.37400925 C17.0804925,6.08924238 15.3066844,7.26972151 13.2997298,8.07304707 C12.0149527,5.69256382 10.6935147,3.70875913 9.63751764,2.26053227 C10.3957792,2.07525084 11.1855114,1.9763072 11.9992997,1.9763072 C14.4765017,1.97548392 16.7429656,2.88071839 18.4934591,4.37400925 Z M7.69128001,2.95123902 C8.71201672,4.31395137 10.0702803,6.28795238 11.3985562,8.70822706 C8.5830859,9.4814825 5.43379594,9.68999619 2.24627985,9.69897604 C2.94975611,6.71700782 4.98521552,4.24499604 7.69128001,2.95123902 Z M1.97696683,11.999135 L1.98520522,11.675119 L2.03916669,11.675119 C5.61067421,11.675119 9.15664272,11.4411487 12.3359204,10.5043612 C12.5729389,10.9866366 12.8061678,11.4815992 13.0342065,11.9908966 C8.85149269,13.2171812 6.24371222,15.9696278 4.45647555,18.5886125 C2.91449579,16.8269972 1.97696683,14.5207419 1.97696683,11.999135 Z M5.91747191,19.9582451 C7.60947278,17.409781 9.96746522,14.8882565 13.8044961,13.8292113 C14.7007507,16.1257453 15.4319904,18.6321936 15.81903,21.2646892 C14.6415167,21.7537201 13.3522908,22.0236922 12.0007826,22.0236922 C9.71396991,22.0236922 7.60502405,21.253485 5.91747191,19.9582451 Z M17.6625349,20.2657842 C17.252263,17.8605034 16.5802574,15.5662761 15.7710002,13.4392882 C17.5245418,13.2165221 19.5404762,13.2705659 21.8774608,13.7002804 C21.4102616,16.4166429 19.8487569,18.7635135 17.6625349,20.2657842 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbble);
export default __webpack_public_path__ + "static/media/dribbble.3e540e1bd36a19ea829f27350309fa73.svg";
export { ForwardRef as ReactComponent };